import { post } from '../request';
import { APP_CONFIG } from '../../config';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { GenerateVoucherResponse } from '@/@types/voucher';

export const generateVoucher = async (campaignType: string): Promise<GenerateVoucherResponse | null> => {
  return await post(
    `${APP_CONFIG.baseApiUrl}${ApiEndpoints.voucherGenerate}?campaignType=${campaignType}`,
    {},
    'XSRF-TOKEN',
  );
};
